"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEFT = void 0;
const tab_1 = require("../../../tab");
exports.LEFT = {
    description: 'Returns the first character or characters in a text string, based on the number of characters you specify',
    arg_names: ['string_to_extract', 'number_of_chars'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['number'],
            required: true,
        },
    ],
    args_description: [
        'the text string containing the characters you want to extract',
        'the number of characters to extract',
    ],
    return_type: tab_1.ColumnType.STRING,
};
